import React, { useState } from 'react'
import { KTIcon } from '../../_metronic/helpers'

interface CopyableCellProps {
  value: string | null | undefined
  mono?: boolean
  /**
   * Чем нарисовать значение — например ссылкой. Копирование при этом остаётся: клик по
   * иконке и по полю оверлея копирует, клик по самому значению отдаётся его обработчику.
   */
  renderValue?: (value: string) => React.ReactNode
}

// Значение с копированием по наведению: обводка + иконка появляются только
// при наведении на сам токен, не перекрывая соседние элементы строки
// (изначально — Audit/AuditPage.tsx, вынесено в общий компонент для повторного
// использования в других списках, CPAYMENT-1739).
export const CopyableCell: React.FC<CopyableCellProps> = ({ value, mono = false, renderValue }) => {
  const [hovered, setHovered] = useState(false)
  const [copied, setCopied] = useState(false)

  if (!value) return <span>—</span>

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation()
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1200)
    })
  }

  const shown = renderValue ? renderValue(value) : value

  const textStyle: React.CSSProperties = {
    fontFamily: mono ? 'monospace' : undefined,
    fontSize: mono ? '0.8rem' : undefined,
    whiteSpace: 'nowrap',
  }

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span style={textStyle}>{shown}</span>
      {hovered && (
        <span
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={handleCopy}
          title={copied ? 'Скопировано' : 'Скопировать'}
          style={{
            position: 'absolute',
            top: '-4px',
            left: '-8px',
            bottom: '-4px',
            width: 'max-content',
            border: '1px solid var(--bs-border-color)',
            borderRadius: '5px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.13)',
            background: 'var(--bs-body-bg)',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            paddingLeft: '8px',
            paddingRight: '8px',
            zIndex: 10,
          }}
        >
          <span style={textStyle}>{shown}</span>
          <KTIcon
            iconName={copied ? 'check-circle' : 'copy'}
            className={`fs-4 ${copied ? 'text-success' : 'text-gray-500'}`}
          />
        </span>
      )}
    </span>
  )
}

export default CopyableCell
